import { makeStyles } from "tss-react/mui";

export const useStyles = makeStyles()((theme) => ({
  container: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(3),
  },
  qaThumbnail: {
    width: 250,
    height: 250,
    objectFit: "contain",
    maxWidth: "100%",
    margin: "0 auto",
  },
  watermark: {
    [theme.breakpoints.down("xl")]: {
      display: "none",
    },
    [theme.breakpoints.up("lg")]: {
      justifyContent: "flex-end",
    },
    [theme.breakpoints.down("lg")]: {
      display: "flex",
    },
  },
  resultThumbnailContainer: {
    position: "relative",
    width: "100%",
    maxWidth: 600,
    maxHeight: "33vh",
    margin: "0 auto",
  },
  resultThumbnail: {
    width: "100%",
    maxWidth: 600,
    maxHeight: "33vh",
    borderRadius: 8,
    objectFit: "contain",
    [theme.breakpoints.down("md")]: {
      maxWidth: "100%",
    },
  },
  tenorAttributionLogoContainer: {
    position: "absolute",
    bottom: 0,
    right: 0,
    zIndex: 100,
    display: "flex",
    justifyContent: "flex-end",
    width: "100%",
    background: "rgba(255, 255, 255, 0.5)",
    paddingBottom: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  tenorAttributionLogo: {
    width: 75,
    filter: `drop-shadow(0px 0px 1px ${theme.palette.primary.main})`,
  },
}));
